import './index.scss'
import React, { useContext, useEffect, useState } from 'react'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'
import PointPreloader from '@Components/Preloaders/PointPreloader'
import DashboardNoDataInfo from '@Scenes/RightsholderScene/RightsholderDashboard/DashboardNoDataInfo'
import DashboardLatestStatementTable from '@Scenes/RightsholderScene/RightsholderDashboard/DashboardLatestStatementsCard/DashboardLatestStatementTable'
import { Link } from 'react-router'
import Navigation from '@App/navigation'
import dayjs, { Dayjs } from 'dayjs'
import PermissionCheck from '@Components/Utility/PermissionCheck'
import { PERMISSIONS } from '@Const/permissions'

const DashboardLatestStatementsCard = () => {
    const { statementsStore, rightsholderStore } = useContext(StoresContext)
    const [usagePeriod, setUsagePeriod] = useState<Dayjs>()
    const [isLoading, setIsLoading] = useState(true)
    const currentRhId = rightsholderStore.currentRightsholderId

    useEffect(() => {
        const controller = new AbortController()
        statementsStore.loadLatestRoyaltiesDate().then(() => {
            const firstUsagePeriod = dayjs(statementsStore.royaltiesUsagePeriodOptions[0].value, 'MM-YYYY')
            setUsagePeriod(firstUsagePeriod)
            statementsStore
                .loadRoyalties(firstUsagePeriod.format('YYYY'), firstUsagePeriod.format('MM'), controller.signal)
                .then(() => setIsLoading(false))
        })
        return () => {
            controller.abort()
        }
    }, [])

    const sortedRoyalties = statementsStore?.royalties
        ?.slice()
        ?.sort((a, b) => b.paymentAmount - a.paymentAmount)
        .slice(0, 3)

    return (
        <div className="dashboard-content-card latest-statements">
            <div className="latest-statements-header">
                <div className="latest-statements-title">
                    Your <span>{usagePeriod?.format('MMMM YYYY')}</span> Statements
                </div>
            </div>
            <>
                {isLoading ? (
                    <PointPreloader />
                ) : sortedRoyalties?.length ? (
                    <>
                        <DashboardLatestStatementTable
                            royalties={sortedRoyalties}
                            rightsholderIpId={rightsholderStore.currentRightsholderId}
                            usagePeriod={statementsStore.royaltiesUsagePeriodOptions[0].label}
                        />
                        <PermissionCheck
                            requiredPermissions={[
                                PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_contact_and_address,
                                PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_banking_and_tax,
                            ]}
                            orIsInternal
                        >
                            <div className="link-container">
                                <Link to={Navigation.rightholder.royalties.root(currentRhId)}>View More</Link>
                            </div>
                        </PermissionCheck>
                    </>
                ) : (
                    <DashboardNoDataInfo type="statements" />
                )}
            </>
        </div>
    )
}

export default observer(DashboardLatestStatementsCard)
